import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';

import { configGetSettings } from 'common/helper/config/get-settings';
import { AutocompleteViewStoreFactory } from 'common/module/autocomplete/view-store.factory';
import { BuildingReviewStoreService } from 'common/service/building-review-store/service';
import { CountryStoreService } from 'common/service/country-store/service';
import { StatsGtmProviderService } from 'common/service/stats-gtm-provider/service';
import { BuildingReviewAutocompleteStoreFactory } from 'desktop/module/building-review/autocomplete/store.factory';

import { BuildingReviewFormViewStore } from './view-store';

export function BuildingReviewFormViewStoreFactory(): BuildingReviewFormViewStore {
  return new BuildingReviewFormViewStore(
    EventEmitterFactory(),
    BuildingReviewStoreService(),
    CountryStoreService(),
    AutocompleteViewStoreFactory(),
    BuildingReviewAutocompleteStoreFactory(),
    configGetSettings(),
    StatsGtmProviderService()
  );
}
